export default __webpack_public_path__ + "static/media/Clientes_Formato_de_operaciones.cab9df64.xlsx";